import React from "react";
import PropTypes from "prop-types";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import { ThemeProvider, createMuiTheme } from "@material-ui/core/styles";
import createBreakpoints from "@material-ui/core/styles/createBreakpoints";
import createTheme from "../theme";
import { useSelector } from "react-redux";

const ThemeWrapper = ({ children }) => {
  const prefersDarkMode = useMediaQuery("(prefers-color-scheme: dark)"); // gets client preference from (browser, computer etc.), if any
  const isDarkMode = useSelector((state) => state.settings.isDarkMode);

  const breakpoints = createBreakpoints({});
  const { theme } = createTheme(breakpoints, false); //isDarkMode || prefersDarkMode
  const muiTheme = createMuiTheme(theme);

  return <ThemeProvider theme={muiTheme}>{children}</ThemeProvider>;
};

ThemeWrapper.propTypes = {
  children: PropTypes.node,
};

export default ThemeWrapper;
